// @ts-check
import { graphql } from 'gatsby';
import React from 'react';
import GatsbyImage from '../components/images/GatsbyImage';
import MaterialUiImage from '../components/images/MaterialUiImage';
import SvgImage from '../components/images/SvgImage';
import { addPx } from '../utils/addPx';

import './ImageSection.scss';

export const query = graphql`
	fragment ImageSectionFragment on Ozk_content_blockModular_blocksCopyContent {
		image {
			width
			height
			image_type {
				...MaterialUiImageFragment
				...SvgImageFragment

				bynder_image {
					image_reference {
						...BynderImageFragment
					}
				}
			}
		}
	}
`;

/**
 * @typedef BynderImageOpt
 * @property {{ image_reference: import('../CSTypes').BynderImageOptions[]}} bynder_image
 */
/**
 * @typedef {BynderImageOpt} BynderImageOptions
 * @typedef {{ svg_image: import('../components/images/SvgImage').SvgImageOptions }} SvgImageOptions
 * @typedef {{ material_ui_icon: import('../components/images/MaterialUiImage').MaterialUiImageOptions }} MaterialUiImageProps
 */
/**
 * @typedef ImageSectionOptions
 * @property {string} width
 * @property {string} height
 * @property {(SvgImageOptions & BynderImageOptions & MaterialUiImageProps)[]} image_type
 */
/**
 * @typedef  ImageSectionProps
 * @property {import('~/contentstack/types').ModelWithLivePreviewAttr<ImageSectionOptions>} [options]

 */
/** @type {React.FC<ImageSectionProps>} */
const ImageSection = ({ options }) => {
	const opt = options?.image_type?.[0];
	if (!opt) {
		return null;
	}

	const width = addPx(options.width);
	const height = addPx(options.height);

	const svg = opt.svg_image;
	const gatsbyImage = opt.bynder_image?.image_reference?.[0];
	const iconImg = opt.material_ui_icon;

	return (
		<div className="img-section-wrapper" style={{ height, width }} {...options.$?.height}>
			{!!svg && <SvgImage className="image-section svg-image" options={svg}/>}
			{!!gatsbyImage && <GatsbyImage className="image-section simple-image" option={gatsbyImage} />}
			{!!iconImg && <MaterialUiImage className="image-section icon-image" options={iconImg} height={options.height} />}
		</div>
	);
};

export default ImageSection;
